import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import useReferentiel from "hooks/useReferentiel";
import { MenuItem, TextField as MuiTextField } from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { Box } from "@mui/system";
// ----------------------------------------------------------------------
// ----------------------------------------------------------------------
const TextField = styled(MuiTextField)(spacing);
export default function SearchUsersByKw({
  filters,
  setfilters,
  handleSearch,
  handleReset,
}) {
  const { refs } = useReferentiel();

  const onReset = () => {
    if (!filters) return;
    setfilters({ keywords: "", refstatus: "" });
    handleReset();
  };
  const refstatus = Array.isArray(refs.refstatus) ? [...refs.refstatus] : [];
  const handleChange = (field, e) => {
    try {
      const newFilters = { ...filters };
      newFilters[field] = e.target.value;
      setfilters(newFilters);
      handleSearch(newFilters);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Box
      component="form"
      sx={{ display: "flex", alignItems: "center", width: "100%" }}
    >
      <TextField
        size="small"
        sx={{ m: 1, width: "25ch" }}
        select
        label="Statut"
        value={filters.refstatus}
        defaultValue={""}
        onChange={(e) => {
          handleChange("refstatus", e);
        }}
      >
        <MenuItem value="">Tous</MenuItem>
        {refstatus.map((option, i) => (
          <MenuItem key={i} value={option.id}>
            {`${option.label}`}
          </MenuItem>
        ))}
      </TextField>
      <Paper
        component="form"
        sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: 500 }}
      >
        <IconButton sx={{ p: "10px" }} aria-label="menu">
          <SearchIcon />
        </IconButton>
        <InputBase
          value={filters.keywords ? filters.keywords : ""}
          onChange={(e) => handleChange("keywords", e)}
          sx={{ ml: 1, flex: 1 }}
          placeholder="Recherche par mots clés (pseudo, email)"
          inputProps={{ "aria-label": "search user app" }}
        />
        <IconButton
          type="button"
          sx={{ p: "10px" }}
          aria-label="search"
          onClick={onReset}
          disabled={
            filters.keywords && filters.keywords.length > 0 ? false : true
          }
        >
          <CloseIcon />
        </IconButton>
      </Paper>
    </Box>
  );
}
